import {Component, OnInit} from '@angular/core';
import {Page} from '../../../shared/models/page.interface';
import {KfRegistration} from '../../../shared/models/kf-registration.interface';
import {KfRegistrationSearch} from '../../../shared/models/kf-registration-search.interface';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {KfRegistrationAdminService} from '../../services/kf-registration-admin.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-kf-registration-admin',
  templateUrl: './kf-registration-admin.component.html',
  styleUrls: ['./kf-registration-admin.component.scss']
})
export class KfRegistrationAdminComponent implements OnInit {

  currentRoute?: string;
  view!: string;
  kfRegistrationPage!: Page<KfRegistration>;
  private search: KfRegistrationSearch = {};
  private pageRequest: PageRequest = {page: 0, size: 100, sort: 'year', direction: 'desc'};

  constructor(private kfRegistrationAdminService: KfRegistrationAdminService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
    this.currentRoute = router.getCurrentNavigation()?.extractedUrl.toString();
  }

  ngOnInit(): void {
    this.search = this.getFiltersFromQueryParams();
    if (this.currentRoute && this.currentRoute.includes('all-registrations')) {
      this.view = 'all';
    } else if (this.currentRoute && this.currentRoute.includes('validation-center')) {
      this.view = 'validation';
    }
    this.kfRegistrationAdminService.getAllKfRegistrations(this.view, this.search, this.pageRequest)
      .subscribe(data => {
        if(this.view === 'validation') {
          this.sortKfRegistration(data.content);
        }
        this.kfRegistrationPage = data;
      });
  }

  loadKfRegistration(event: PageRequest): void {
    this.kfRegistrationAdminService.getAllKfRegistrations(this.view, this.search, event)
      .subscribe(data => {
        if(this.view === 'validation') {
          this.sortKfRegistration(data.content);
        }
        this.pageRequest = data;
        this.kfRegistrationPage = data;
      });
  }

  searchKfRegistration(event: KfRegistrationSearch): void {
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: this.buildQueryParams(event)});
    this.kfRegistrationAdminService.getAllKfRegistrations(this.view, event, this.pageRequest)
      .subscribe(data => {
        if(this.view === 'validation') {
          this.sortKfRegistration(data.content);
        }
        this.search = event;
        this.kfRegistrationPage = data;
      });
  }

  private buildQueryParams(search: KfRegistrationSearch): any {
    const queryParams = {};

    if (search.startYear) {
      Object.assign(queryParams, {startYear: search.startYear});
    }
    if (search.endYear) {
      Object.assign(queryParams, {endYear: search.endYear});
    }
    if (search.keyFigures && search.keyFigures !== '') {
      Object.assign(queryParams, {keyFigures: search.keyFigures});
    }
    if (search.b2bb2c && search.b2bb2c !== '') {
      Object.assign(queryParams, {b2bb2c: search.b2bb2c});
    }
    if (search.entry && search.entry !== '') {
      Object.assign(queryParams, {entry: search.entry});
    }
    if (search.schemaKind && search.schemaKind !== '') {
      Object.assign(queryParams, {schemaKind: search.schemaKind});
    }
    if (search.status) {
      Object.assign(queryParams, {status: search.status});
    }

    return queryParams;
  }

  private getFiltersFromQueryParams(): KfRegistrationSearch {
    const search = {} as KfRegistrationSearch;
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.startYear) {
        search.startYear = params.startYear;
      }
      if (params.endYear) {
        search.endYear = params.endYear;
      }
      if (params.keyFigures) {
        search.keyFigures = params.keyFigures;
      }
      if (params.b2bb2c) {
        search.b2bb2c = params.b2bb2c;
      }
      if (params.status) {
        search.status = params.status;
      }
      if (params.entry) {
        search.entry = params.entry;
      }
      if (params.schemaKind) {
        search.schemaKind = params.schemaKind;
      }
    });
    return search;
  }

  sortKfRegistration(data:KfRegistration[]): void {
    data.sort((a: KfRegistration, b: KfRegistration) => {
      if(a.status < b.status) return -1;
      if(a.status > b.status) return 1;

      return b.year- a.year;
  });
  }

}
